import { atom, useAtomValue, useSetAtom } from 'jotai';

interface AdjustRelateKnowledgeMeta {
  message: Conversation.Message;
  conversation: Conversation.Conversation;
  knowledgeQuery: Conversation.KnowledgeQueryMessage;
}

const adjustRelateKnowledgeState = atom<AdjustRelateKnowledgeMeta | null>(null);

export const useAdjustRelateKnowledgeValue = () => useAtomValue(adjustRelateKnowledgeState);
export const useSetAdjustRelateKnowledge = () => useSetAtom(adjustRelateKnowledgeState);

export const useAdjustRelateKnowledge = () => {
  const value = useAdjustRelateKnowledgeValue();
  const setValue = useSetAdjustRelateKnowledge();

  const show = (meta: AdjustRelateKnowledgeMeta) => {
    setValue(meta);
  };

  const hide = () => {
    setValue(null);
  };

  return {
    visible: !!value,
    meta: value,
    show,
    hide,
  };
};
